import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-input n-readonly-input" }

import { watch, ref } from 'vue';
import { useClipboard } from '@vueuse/core';
import NButton from '../../control/button/button.vue';
import NSplitInputButton from '../split-input-button/split-input-button.vue';
import NTextInput from '../text-input/text-input.vue';
import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-readonly-input',
},
  __name: 'read-only-input',
  props: {
  id: {
    type: String,
    default: () => '',
  },
  label: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  helpText: {
    type: String,
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
},
  emits: ["copy"],
  setup(__props, { emit: __emit }) {



const props = __props;

const { inputId } = useIdGenerator(props.id);

const readonlyValue = ref('');
const { copy } = useClipboard();

watch(
  () => props.value,
  () => (readonlyValue.value = props.value),
  { immediate: true },
);

const emit = __emit;

async function copyValue() {
  await copy(readonlyValue.value);
  emit('copy');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NSplitInputButton, {
      label: __props.label,
      hideLabel: __props.hideLabel,
      helpText: __props.helpText,
      id: _unref(inputId),
      value: readonlyValue.value
    }, {
      input: _withCtx(() => [
        _createVNode(NTextInput, {
          class: "n-readonly-input__input",
          modelValue: readonlyValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((readonlyValue).value = $event)),
          id: _unref(inputId),
          disabled: true
        }, null, 8, ["modelValue", "id"])
      ]),
      button: _withCtx(() => [
        _createVNode(NButton, {
          icon: "copy",
          variant: "split",
          class: "n-readonly-input__button",
          onClick: copyValue
        })
      ]),
      _: 1
    }, 8, ["label", "hideLabel", "helpText", "id", "value"])
  ]))
}
}

})